import {useLanguagesQuery} from "../../types.d";
import * as React from "react";
import {useEffect, useState} from "react";

export interface LanguageFilterProps {
    filter?: any;
    onChange: (id: number) => any;
}

export const LanguageFilter = (props: LanguageFilterProps) => {
    const [value, setValue] = useState<number>();
    const languages = useLanguagesQuery();

    const languagesList = languages.data ? (
        props.filter ? languages.data.languages.filter(props.filter) : languages.data.languages
    ) : null;

    useEffect(() => {
        if (languagesList && !value) {
            const en = languagesList.filter(item => item.code === 'EN');

            const lang = en.length ? (
                en[0].id
            ) : (
                languagesList[0].id
            );

            setValue(lang);
            props.onChange(lang);
        }
    });

    return <select
        className={'form-control'}
        onChange={value => {
            const id = Number(value.currentTarget.value);
            setValue(id);
            props.onChange(id);
        }}
        value={value}
    >
        { languagesList && languagesList.map(item => (
            <option
                value={item.id}
                key={item.id}>{ item.name } ({ item.code })</option>
        )) }
    </select>
};
